import {AccountTypeEntityModel} from "../../account-type-entity.model";
import {EditService} from "../../../../framework/entity/edit/edit-page/edit.service";
import {Component} from "@angular/core";

@Component({
    selector: "wbo-account-type-edit-payment-settings",
    templateUrl: "./account-type-edit-payment-settings.component.html"
})
export class AccountTypeEditPaymentSettingsComponent {
    constructor(public model: AccountTypeEntityModel, public editService: EditService) {
    }
}
